<template>
    <div id="footer">
        <mu-row>
            <mu-col :span="12" :xl="9">
                <mu-row class="d-flex justify-content-between align-items-center">
                    <mu-col v-for="(brand, index) of images_footer.brands" :key="index" class="footer-logo">
                        <a :href="brand.link" target="_blank">
                            <picture>
                                <source :srcset="`${brand.src}.webp`" type="image/webp" :alt="brand.alt"
                                    :height="brand.height" :width="brand.width">
                                <img :src="`${brand.src}.png`" :alt="brand.alt" :height="brand.height">
                            </picture>
                        </a>
                    </mu-col>
                </mu-row>
            </mu-col>
            <mu-col :span="12" :xl="3" class="h-100" style="height: 100%">
                <mu-row>
                    <mu-col :span="2" class="mt-5" v-for="(social_icon, index) of images_footer.social_icons"
                        :key="index">
                        <a :href="social_icon.link" target="_blank">
                            <img :src="social_icon.src" :alt="social_icon.alt" height="30">
                        </a>
                    </mu-col>
                </mu-row>
                <!-- <mu-row>
                    <mu-col :span="6" :lg="6" :xl="6" class="px-2 my-3">
                        <a href="https://play.google.com/store/apps/details?id=com.vallartaplus.tepicplus">
                            <img src="/images/static/badge_play_es.png" :alt="$t('alt.android')" class="img-android">
                        </a>
                    </mu-col>
                    <mu-col :span="6" :lg="6" :xl="6" class="px-2 my-3">
                        <a href="https://apps.apple.com/mx/app/vallartaplus/id1565439598?mt=8">
                            <img src="/images/static/badge_app_es.svg" :alt="$t('alt.ios')" class="img-ios">
                        </a>
                    </mu-col>
                </mu-row> -->
            </mu-col>
        </mu-row>

        <mu-row align-items="center">
            <mu-col :span="6" :md="2" v-for="(info, index) in information" :key="index" class="footer-menu-txt">
                <router-link :to="info.link" @click="info.toggle">
                    <span>{{ info.title }}</span>
                </router-link>
            </mu-col>
        </mu-row>

        <mu-row class="mt-1">
            <mu-col :span="12" class="text-center">
                {{ $t('copyright') }}
            </mu-col>
        </mu-row>
    </div>
</template>

<script>
    //JSON
	const foot = require('~/assets/json/footer.json')

    export default {
       data(){
            return{
                images_footer : {
                    brands: [
                        {
                            src:"/images/logos/vallartaplus_1",
                            alt:"Tepic Plus",
                            link: "https://www.vallartaplus.com/",
                            height: "110",
                            width: "150"
                        },
                        {
                            src:"/images/logos/tequilaplus_1",
                            alt:"Tequila Plus",
                            link: "https://www.tequilaplus.com/",
                            height: "110",
                            width: "150"
                        },
                        {
                            src:"https://vp-traveller-public.s3.us-east-1.amazonaws.com/logos/gopost_blanco",
                            alt:"Gopost",
                            link: "https://www.gopost.mx/",
                            height: "90",
                            width: "195"
                        },
                        {
                            src:"/images/logos/aztecaplus_1",
                            alt:"Azteca Plus",
                            link: "http://www.aztecaplus.mx/",
                            height: "150",
                            width: "200"
                        },
                        {
                            src:"/images/logos/tepicplus_1",
                            alt:"Tepic Plus",
                            link: "http://www.tepicplus.mx/",
                            height: "110",
                            width: "150"
                        },
                        // {
                        //     src: "/images/logos/vacations_1",
                        //     alt: "Azteca Plus",
						// 	link: "https://www.vallartaplusvacations.com/",
                        //     height: "90",
                        //     width: "130"
                        // }
                    ],
                    social_icons:[
                        {
                            src:"/images/social_icons/facebook.png",
                            alt:"Facebook Tepic Plus",
                            link: "https://www.facebook.com/profile.php?id=61581577097865"
                        },
                        // {
                        //     src:"/images/social_icons/instagram.png",
                        //     alt:"Instagram Tepic Plus",
                        //     link: "https://www.instagram.com/tepicplus/"
                        // },
                        // {
                        //     src:"/images/social_icons/youtube.png",
                        //     alt:"Youtube Tepic Plus",
                        //     link: "https://www.youtube.com/@TepicPlusOficial"
                        // },
                        // {
                        //     src:"/images/social_icons/whatsapp.png",
                        //     alt:"Whatsapp Tepic Plus",
                        //     link: "https://api.whatsapp.com/send?phone=523316995879"
                        // },
                        // {
                        //     src:"/images/social_icons/g.png",
                        //     alt:"Ubicación en google maps",
                        //     link: "https://goo.gl/maps/MXK8nKFW8N9sFEt36"
                        // },
                        // {
                        //     src: "/images/social_icons/tiktok.svg",
                        //     alt:"Tiktok Tepic Plus",
                        //     link: "https://www.tiktok.com/@tepic.plus"
                        // }
                    ]
                },
                information: foot.es.info
            }
        },
    }
</script>
<style lang="scss">
#footer {
	background-color: black;
	text-align: center;
	padding: 2rem;
	color: white;
	right: 0;
	left: 0;
	bottom: 0px;
	position: relative;

	.footer-logo {
		float: left;
		width: 20%;
		padding: 10px 10px;
	}

        
}

@media (max-width: 1099px) {
	#footer .footer-logo {
		width: 50%;
	}

	#footer .footer-logo.social-container {
		width: 100%;
	}
}

@media (max-width: 991px) {
	#footer .footer-logo {
		width: 50%;
	}

	#footer .footer-logo.social-container {
		width: 100%;
	}
}

@media (max-width: 480px) {
	#footer .footer-logo {
		width: 50%;
	}
	#footer {
		padding: 0 0.5rem
	}
}

@media (max-width: 574px) {
	.logo {
		margin-left: 22%;
	}
	#footer {
		padding: 0 0.5rem
	}
}
@media (max-width: 320px) {
	#footer .footer-logo {
		width: 100%;
	}
	.logo {
		margin-left: 9%;
	}
	#footer {
		padding: 0 0.5rem
	}
}

#footer .footer-menu-txt {
	float: left;
	width: 86%;
	text-align: center;
	padding: 10px 10px;

	font-size: 14px;
}

#footer .footer-menu-txt a {
	color: white;
}

@media (max-width: 991px) {
	#footer .footer-menu-txt {
		width: 100%;
	}
}

@media (max-width: 480px) {
	#footer .footer-menu-txt {
		width: 100%;
	}
	#footer {
		padding: 0 0.5rem
	}
}
@media (max-width: 320px) {
	#footer .footer-menu-txt {
		width: 100%;
		margin-left: 25%;
	}
	#footer {
		padding: 0 0.5rem
	}
}

.img-android {
	width: 160px;
	height: 50px;
}
.img-ios {
	width: 160px;
	height: 50px;
}
/* Medium and small screen */
@media only screen and (max-width: 991px) {
	.img-ios,
	.img-android {
		width: 160px;
		height: 50px;
	}
}
@media only screen and (max-width: 350px) {
	.img-android {
		width: 160px;
		height: 50px;
	}
}
</style>
